module.exports = __webpack_public_path__ + "static/media/ship-cookie-box.7a0f48db.png";